export default "__VITE_ASSET__Dyh7PudG__"